import Icons from 'components/Icons'
import { ShieldCheck, CreditCard, DollarSign, Lock } from 'lucide-react'
import Heading from 'components/Typography/Header'
import Paragraph from 'components/Typography/Paragraph'

const FeatureTwo = () => {
    return (
        <section className='py-24 md:py-40 relative overflow-hidden'>
            <div className='absolute inset-0 bg-gradient-to-tl from-secondary/5 via-transparent to-primary/5'></div>
            
            <div className='max-w-7xl mx-auto px-6 relative z-10'>
                <div className='max-w-4xl mx-auto text-center'>
                    <div className='space-y-10'>
                        <div className='inline-flex items-center gap-3 px-4 py-2 bg-gradient-to-r from-secondary/10 to-primary/10 rounded-full border border-secondary/20'>
                            <Icons className="bg-gradient-to-r from-secondary to-primary p-2 rounded-lg"> 
                                <ShieldCheck size={24} className="text-white" /> 
                            </Icons>
                            <span className="text-secondary font-semibold text-sm">%100 Güvenli Ödemeler</span>
                        </div>

                        <div className='space-y-6'>
                            <Heading level={1} className="text-white text-5xl lg:text-6xl font-bold leading-tight bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                                SSL Sertifikalı<br />
                                <span className="bg-gradient-to-r from-secondary to-primary bg-clip-text text-transparent">Güvenli Platform</span>
                            </Heading>
                            <Paragraph className="text-gray-300 text-xl leading-relaxed ">
                                SkyPay, SSL sertifikalı güvenli altyapısı ve şeffaf hesap yönetimi ile %100 güvenli ödeme deneyimi sunar. Çoklu ödeme yöntemleri ve rekabetçi fiyatlarla tasarruf edin.
                            </Paragraph>
                        </div>

                        <div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
                            <div className='group p-6 bg-gradient-to-br from-gray-900/80 to-gray-900/60 rounded-2xl border border-gray-700/50 backdrop-blur-sm hover:border-secondary/30 transition-all duration-300 hover:transform hover:scale-105'>
                                <div className='text-center space-y-4'>
                                    <div className='mx-auto w-16 h-16 p-3 bg-gradient-to-r from-secondary to-primary rounded-xl flex items-center justify-center group-hover:shadow-lg group-hover:shadow-secondary/25 transition-all duration-300'>
                                        <CreditCard size={28} className='text-white' />
                                    </div>
                                    <div>
                                        <h4 className='text-white font-bold text-xl mb-3 group-hover:text-secondary transition-colors duration-300'>Çoklu Ödeme Yöntemleri</h4>
                                        <Paragraph className='text-gray-300 leading-relaxed'>Kredi kartı, banka kartı ile güvenli ödeme seçenekleri.</Paragraph>
                                    </div>
                                </div>
                            </div>

                            <div className='group p-6 bg-gradient-to-br from-gray-900/80 to-gray-900/60 rounded-2xl border border-gray-700/50 backdrop-blur-sm hover:border-primary/30 transition-all duration-300 hover:transform hover:scale-105'>
                                <div className='text-center space-y-4'>
                                    <div className='mx-auto w-16 h-16 p-3 bg-gradient-to-r from-primary to-secondary rounded-xl flex items-center justify-center group-hover:shadow-lg group-hover:shadow-primary/25 transition-all duration-300'>
                                        <DollarSign size={28} className='text-white' />
                                    </div>
                                    <div>
                                        <h4 className='text-white font-bold text-xl mb-3 group-hover:text-primary transition-colors duration-300'>Rekabetçi Fiyatlar</h4>
                                        <Paragraph className='text-gray-300 leading-relaxed'>Piyasanın en uygun fiyatları ile oyun kredilerinizi satın alın, daha fazla tasarruf edin.</Paragraph>
                                    </div>
                                </div>
                            </div>

                            <div className='group p-6 bg-gradient-to-br from-gray-900/80 to-gray-900/60 rounded-2xl border border-gray-700/50 backdrop-blur-sm hover:border-secondary/30 transition-all duration-300 hover:transform hover:scale-105'>
                                <div className='text-center space-y-4'>
                                    <div className='mx-auto w-16 h-16 p-3 bg-gradient-to-r from-secondary to-primary rounded-xl flex items-center justify-center group-hover:shadow-lg group-hover:shadow-secondary/25 transition-all duration-300'>
                                        <Lock size={28} className='text-white' />
                                    </div>
                                    <div>
                                        <h4 className='text-white font-bold text-xl mb-3 group-hover:text-secondary transition-colors duration-300'>256-bit SSL Şifreleme</h4>
                                        <Paragraph className='text-gray-300 leading-relaxed'>Bankacılık seviyesinde güvenlik protokolleri ile tüm verileriniz korunur.</Paragraph>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FeatureTwo